import { FC } from 'react';
import type { QualidadeLote } from '@/types/dashboards';
import { type ModoTema, visualStatusLote } from '../chartTheme';

/** Status do lote com ícone + rótulo, e as marcas que mudam a leitura (condicional, reprocesso). */
const StatusLoteBadge: FC<{ lote: QualidadeLote; modo: ModoTema }> = ({ lote, modo }) => {
  const v = visualStatusLote(lote.status, modo);
  return (
    <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs">
      <span className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-content-primary">
        <span aria-hidden className="material-symbols-outlined text-[16px] leading-none" style={{ color: v.cor }}>
          {v.icone}
        </span>
        {v.rotulo}
      </span>
      {lote.condicional && <span className="rounded bg-surface-hover px-1.5 py-0.5 text-content-secondary">condicional</span>}
      {lote.reprocesso && <span className="rounded bg-surface-hover px-1.5 py-0.5 text-content-secondary">reprocesso</span>}
    </span>
  );
};

export default StatusLoteBadge;
